import firebase from "firebase";
import Firebase from './Firebase';

class BillingApi {
    async reinstateSubscription(stripe) {
        let sessionResponse = await Firebase.fetch('/stripe/startPaymentSession', {
            method: 'POST'
        });

        console.log(sessionResponse);
        return await stripe.redirectToCheckout({sessionId: sessionResponse.sessionId});

        //TODO error handle
    }


    async getStripeDetails(detail) {
        try {
            let details = await firebase.functions().httpsCallable(detail)();
            return details;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    async pay() {
        try {
            await firebase.functions().httpsCallable('beginSubscription')();
            await firebase.auth().currentUser.getIdToken(true);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    async resetBillingDays() {
        try {
            await firebase.functions().httpsCallable('resetBillingDays')();
            await firebase.auth().currentUser.getIdToken(true);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    async addMonth(stripe) {
        try {
            let data = await firebase.functions().httpsCallable('addMonth')();
            let redirect = await stripe.redirectToCheckout({
                sessionId: data.data.sessionId
            })
            console.log(redirect)
            return data
            // await firebase.auth().currentUser.getIdToken(true);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    async deauthorize() {
        try {
            await firebase.functions().httpsCallable('deauthorize')();
            await firebase.auth().currentUser.getIdToken(true);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}

export default new BillingApi();
